export const BID = "BID";
export const GET_BID_COUNT_SHWE_HOUR = "GET_BID_COUNT_SHWE_HOUR";